import { useSelector } from "react-redux";

import makeRadioOptionsFilter from "../components/makeRadioOptionsFilter";

const useOptions = () => {
  const channels = useSelector((state: any) => state.currentUser.channels);
  return channels;
};

const filterChannel = makeRadioOptionsFilter({
  name: "channel",
  title: "Channel",
  useOptionsHook: useOptions,
});

export default filterChannel;
